export default __webpack_public_path__ + "static/media/apple_swift.ea0db916.jpeg";